export const PREPARATION_METHOD_LABELS = {
  water: 'Water-Based',
  milk: 'Milk-Based',
  both: 'Both Water & Milk',
};

/** Whether an ingredient can be used with the given preparation method. */
export function isIngredientCompatibleWithPreparation(ingredient, preparationMethod) {
  if (!ingredient?.preparation_methods || ingredient.preparation_methods.length === 0) {
    return true;
  }
  if (preparationMethod === 'both') {
    return (
      ingredient.preparation_methods.includes('water')
      && ingredient.preparation_methods.includes('milk')
    );
  }
  return ingredient.preparation_methods.includes(preparationMethod);
}

/** Selected ingredients that would not work with the target preparation method. */
export function getIncompatibleSelectedIngredients(ingredients, selectedIds, preparationMethod) {
  const selectedSet = new Set(selectedIds);
  return ingredients.filter(
    (ing) => selectedSet.has(ing.id)
      && !isIngredientCompatibleWithPreparation(ing, preparationMethod),
  );
}
